// Per-tab in-memory cache for analytics responses.
// Key: tab + time_window + user_id (if any). TTL scoped to the time_window.

const TTL_BY_WINDOW_MS = {
  '24h': 5 * 60 * 1000,
  '7d': 30 * 60 * 1000,
  '30d': 60 * 60 * 1000,
  '90d': 6 * 60 * 60 * 1000,
  all: 12 * 60 * 60 * 1000,
};

const cache = new Map();

function _key(tab, timeWindow, userId) {
  return `${tab}::${timeWindow}::${userId || 'ALL'}`;
}

export function getAnalyticsCached(tab, timeWindow, userId) {
  const k = _key(tab, timeWindow, userId);
  const entry = cache.get(k);
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) {
    cache.delete(k);
    return null;
  }
  return entry.data;
}

export function setAnalyticsCached(tab, timeWindow, userId, data) {
  const ttl = TTL_BY_WINDOW_MS[timeWindow] ?? 5 * 60 * 1000;
  cache.set(_key(tab, timeWindow, userId), {
    data,
    expiresAt: Date.now() + ttl,
  });
}

export function invalidateAnalyticsCache() {
  cache.clear();
}
